import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './GrianaStepSix.scss';
import DataPreview from './DataPreview';
import { GRIDPRO_STYLE } from '../../constant/GRIDPRO_STYLE';
import { Loading } from '@bvt-features/account/component';

/**
 * @param {object} props
 * @param {JSX.Element | HTMLElement} props.children
 * @param {func} props.onBack
 * @param {func} props.showDashboard
 * @param {func} props.addMarker
 * @param {object} props.dataPreview
 * @param {object} props.dataPreview.changeArea
 * @param {func} props.dataPreview.changeArea.onClick
 * @param {object} props.dataPreview.selectOption
 * @param {Array<{label: string, value: string, acceptable: string}>} props.dataPreview.selectOption.data
 * @param {string} props.dataPreview.selectOption.value
 * @param {func} props.dataPreview.selectOption.onChange
 */
export default function GrianaStepSix(props) {
  const [stepHeight, setStepHeight] = useState(0);
  const [wrapperHeight, setWrapperHeight] = useState(0);

  const getClientHeight = (value) => {
    const docs = document.querySelector(value);
    return docs ? docs.clientHeight : 0;
  };
  const handleHeight = () => {
    const container = getClientHeight('.mainmap-sl-sider-container');
    const heading = getClientHeight('.mainmap-sl-sider-heading');
    const header = getClientHeight('.DataPreview');
    const footer = getClientHeight('.grianastepsix--footer');
    const step = container - header - heading;
    setStepHeight(step);
    setWrapperHeight(step - footer);
  };
  useEffect(() => {
    handleHeight();
    window.addEventListener('resize', handleHeight);
    return () => {
      window.removeEventListener('resize', handleHeight);
    };
  }, []);
  const generateStyle = (value) => {
    return {
      minWidth: '1rem',
      minHeight: '1rem',
      backgroundColor: GRIDPRO_STYLE.find((ctx) => ctx.gridStatus === value)
        .style.unselected.fillColor,
      opacity: '0.7',
    };
  };
  const content = (
    <div
      className='feature-griana grianastepsix--wrapper'
      style={{ height: wrapperHeight }}
    >
      {props?.children}
    </div>
  );

  const loader = (
    <div
      className='feature-griana grianastepsix--loading-wrapper'
      style={{ height: wrapperHeight }}
    >
      <Loading height='2rem' width='2rem' />
    </div>
  );

  return (
    <div
      className='feature-griana grianastepsix'
      style={{ height: stepHeight }}
    >
      <div className='feature-griana grianastepsix--header'>
        <DataPreview
          changeArea={{
            onClick: () =>
              props.dataPreview.changeArea.onClick &&
              props.dataPreview.changeArea.onClick(),
          }}
          isLoading={props.isAreaLoading}
          selectOption={{
            value: props.dataPreview.selectOption.value,
            data: props.dataPreview.selectOption.data.map((ctx) => {
              return {
                value: ctx.value,
                label: (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                    }}
                  >
                    <div style={generateStyle(ctx.acceptable)} />{' '}
                    <span>{ctx.label}</span>
                  </div>
                ),
              };
            }),
            onChange: (e) => {
              props.dataPreview.selectOption.onChange &&
                props.dataPreview.selectOption.onChange(e);
            },
          }}
          showChange={true}
        />
      </div>
      {props.isDetailLoading ? loader : content}
      <div className='feature-griana grianastepsix--footer'>
        <button
          className='feature-griana grianastepsix--footer_btn_outline'
          onClick={props?.onBack}
        >
          Back
        </button>
        <div className='feature-griana grianastepsix--footer_right'>
          <button
            className='feature-griana grianastepsix--footer_btn_outline'
            disabled={props?.isAreaLoading || props?.isDetailLoading}
            onClick={props?.addMarker}
          >
            Add New Marker
          </button>
          <button
            className={`feature-griana grianastepsix--footer_btn_fill`}
            onClick={props?.showDashboard}
          >
            Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}

GrianaStepSix.defaultProps = {
  dataPreview: {
    changeArea: {
      onClick: undefined,
    },
    selectOption: {
      data: [
        { label: 'GRID - 83478', value: '89734' },
        { label: 'GRID - 834783', value: '834783' },
      ],
      value: '834783',
      onChange: undefined,
    },
  },
  isAreaLoading: true,
  isDetailLoading: true,
};

GrianaStepSix.propTypes = {
  children: PropTypes.node,
  dataPreview: PropTypes.shape({
    changeArea: PropTypes.shape({
      onClick: PropTypes.func,
    }),
    selectOption: PropTypes.shape({
      data: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
          value: PropTypes.string,
          acceptable: PropTypes.string,
        })
      ),
      value: PropTypes.string,
      onChange: PropTypes.func,
    }),
  }),
  isAreaLoading: PropTypes.bool,
  isDetailLoading: PropTypes.bool,
  onBack: PropTypes.func,
  saveExit: PropTypes.func,
  showDashboard: PropTypes.func,
};
